const NAME = "HEALTH_DEFINITION";

export default NAME;
